
import { computed, defineComponent, onMounted, reactive, toRefs, watch } from 'vue'
import i18n from "@/locales/index";
export default defineComponent({
    props: {
        noDataHeight: {
            type: Number,
            default: 695
        }
    },
    setup(props) {


    }
})

